import { render, staticRenderFns } from "./RecentItems.vue?vue&type=template&id=f9e6cba2"
import script from "./RecentItems.vue?vue&type=script&lang=js"
export * from "./RecentItems.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports